import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Viewer } from '../../../widgets/Viewer';
import { RenderInput } from './Base';

import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

import { saveRecipientMiscDoc } from '../../../../redux/actions/recipientMiscDoc.actions';

const mapStateToProps = (state) => ({
    recipientMiscDoc: state.recipientMiscDoc
});

class AddRecipientMiscDocModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            dropbox_image_share_url: '',
            filename: '',
            image: '', // Base 64
            notes: ''
        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-recipient-misc-doc-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-recipient-misc-doc-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { recipientMiscDoc: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, file, value }) => {
        const { form } = this.state;

        // Extract last file
        if (file && file[0]) {
            const reader = new FileReader();
            const lastFile = file[0];
            reader.readAsDataURL(lastFile);
            reader.onloadend = () => {
                form.image = reader.result;
                this.setState({ form });
            }
            form.filename = lastFile.name;
        }

        if (text !== undefined) {
            form[value] = text;
        }
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveRecipientMiscDoc();
        }
    }
    saveRecipientMiscDoc = () => {
        const newForm = { ...this.state.form }
        if (newForm.image) {
            newForm.image = newForm.image.split(',')[1];
        }
        this.props.saveRecipientMiscDoc(newForm);
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.recipientMiscDoc;
        return (
            <Dialog icon='document'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                canOutsideClickClose={false}
                title="Add Recipient Document">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="Notes"
                                    name="notes"
                                    value={form.notes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput name="filename"
                                    type="upload"
                                    value={form.filename}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                { form.image || form.dropbox_image_share_url ?
                                     <div className="flex-column">
                                        <Viewer src={form.image || form.dropbox_image_share_url || ''} style={{ width: '100%' }} />
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Save Document" onClick={this.saveRecipientMiscDoc} isLoading={saveLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveRecipientMiscDoc }
)(AddRecipientMiscDocModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/RecipientMiscDocModal.jsx